<template>
    <input class="input" type="datetime-local" v-model="internalValue" />
</template>

<script>
    /**
     * Input value must be in format: yyyy-mm-ddThh:mm to be correctly interpreted in Chrome.
     */
    export default {
        name: "native-date-time-picker",
        props: ["modelValue"],
        computed: {
            internalValue: {
                set(value) {
                    this.$emit("update:modelValue", convertToSpaceFormat(value));
                },
                get() {
                    return convertToTFormat(this.modelValue);
                },
            },
        },
    };

    function convertToTFormat(str) {
        if (!str) {
            return str;
        }

        if (str.indexOf(" ") === -1) {
            return str;
        }
        return str.split(" ").join("T");
    }

    function convertToSpaceFormat(str) {
        if (!str) {
            return str;
        }

        if (str.indexOf("T") === -1) {
            return str;
        }

        return str.split("T").join(" ");
    }
</script>

<style scoped></style>
